import styled from 'styled-components';
import { Input, Modal } from 'antd';

export const SInput = styled(Input)`
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;

  &:focus {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

export const SModal = styled(Modal)`
  .ant-modal-header {
    .ant-modal-title {
      font-weight: 700;
      font-size: 24px;
      margin-bottom: 8px;
    }
  }

  .ant-modal-body {
    padding: 16px 0;
  }
`;
